import { render, staticRenderFns } from "./LeftSidebarLayout.vue?vue&type=template&id=7922c023&scoped=true&"
import script from "./LeftSidebarLayout.vue?vue&type=script&lang=js&"
export * from "./LeftSidebarLayout.vue?vue&type=script&lang=js&"
import style0 from "./LeftSidebarLayout.vue?vue&type=style&index=0&id=7922c023&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7922c023",
  null
  
)

export default component.exports